document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-furlan-bundle-add]');

  if (!button) return;

  const bundle = button.closest('.furlan-bundle');

  if (!bundle) return;

  const message = bundle.querySelector('[data-furlan-bundle-message]');

  const products = [...bundle.querySelectorAll('[data-bundle-product]')];

  const items = products
    .filter((product) => {
      const checkbox = product.querySelector('[data-bundle-checkbox]');
      return checkbox?.checked;
    })
    .map((product) => {
      const variant = product.querySelector('[data-bundle-variant]');

      return {
        id: Number(variant.value),
        quantity: 1
      };
    })
    .filter((item) => item.id);

  if (!items.length) {
    if (message) {
      message.hidden = false;
      message.textContent = 'Select at least one product.';
    }

    return;
  }

  button.disabled = true;

  const originalText = button.textContent;

  button.textContent = 'ADDING...';

  if (message) {
    message.hidden = true;
  }

  try {

    const response = await fetch(
      `${window.Shopify?.routes?.root || '/'}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items
        })
      }
    );

    if (!response.ok) {
      throw new Error('Unable to add products.');
    }

    await response.json();

    button.textContent = 'ADDED ✓';

    if (message) {
      message.hidden = false;
      message.textContent = 'Products added to your cart.';
    }

    setTimeout(() => {
      window.location.href = '/cart';
    }, 600);

  } catch (error) {

    console.error(error);

    button.disabled = false;
    button.textContent = originalText;

    if (message) {
      message.hidden = false;
      message.textContent = 'Something went wrong. Please try again.';
    }

  }
});